import Vec2 from 'vec2';

import { DrawingShapeContextType } from './drawingShape.types';

export const drawingShapeContextInitialValue: DrawingShapeContextType = {
  getters: {
    activeDrawingApplianceId: undefined,
    activeDrawingAppliance: undefined,
    activeDrawingItem: undefined,
    activeDrawingObject: undefined,
    activeDrawingShape: undefined,
    actualDrawingShapes: [],
    areThereShapesInTheDrawingArea: false,
    drawingShapes: [],
    numberOfShapesInTheDrawingArea: 0,
    showNotification: {},
    selectedSinksInDrawing: [],
    isCornerRadiusConstraintModalOpen: false,
  },
  handlers: {
    autoPlaceShapeTranslation: () => new Vec2([]),
    resetActiveShape: () => undefined,
    resetDrawingShapes: () => undefined,
    updateActiveDrawingAppliance: () => undefined,
    updateActiveDrawingShapeId: () => undefined,
    updateDrawingShapes: () => undefined,
    updateShowNotification: () => undefined,
    setIsCornerRadiusConstraintModalOpen: () => undefined,
  },
};
